import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ApiResponse,
  SettingsPayload,
  UpdateProfileRequest,
  User,
} from '@victory-lib-ui/shared/models';
import { BaseApiService } from './base-api.service';

@Injectable({
  providedIn: 'root',
})
export class SettingsApiService extends BaseApiService {
  constructor() {
    super('settings');
  }

  getSettings(): Observable<ApiResponse<SettingsPayload>> {
    return this.get<ApiResponse<SettingsPayload>>('');
  }

  getProfile(): Observable<ApiResponse<User>> {
    return this.get<ApiResponse<User>>('/profile');
  }

  updateProfile(payload: UpdateProfileRequest): Observable<ApiResponse<User>> {
    return this.put<ApiResponse<User>>('/profile', payload);
  }

  uploadProfileImage(file: File): Observable<ApiResponse<User>> {
    const formData = new FormData();
    formData.append('avatar', file);

    return this.post<ApiResponse<User>>('/profile/avatar', formData);
  }
}
